export default [
  {
    path: '/active-borderline/index',
    name: 'index',
    component: () => import('@/views/active-borderline/index'),
    meta: {
      title: '2024高考分数线神预测，猜对瓜分万元奖金！'
    }
  },  
]
